import React, { useState } from 'react';
import { getFileExtension } from '../utils/mediaTypes';

function sourceTypeFor(filename) {
	const ext = getFileExtension(filename);
	if (ext === 'webm') return 'video/webm';
	// Hint mp4 for .mov so Chrome/Edge attempt H.264 instead of skipping video/quicktime.
	return 'video/mp4';
}

export default function AttachmentVideo({ src, filename, style }) {
	const [failed, setFailed] = useState(false);

	if (!src) return null;

	if (failed) {
		return (
			<div className="text-center text-muted p-2">
				This video could not be played in this browser. iPhone recordings (.MOV) often
				use a format Chrome and Edge cannot play. Download the file, or open it in Safari.
			</div>
		);
	}

	return (
		<video
			controls
			autoPlay={false}
			preload="metadata"
			playsInline
			onError={() => setFailed(true)}
			style={{ maxWidth: '100%', maxHeight: 480, ...style }}
		>
			<source src={src} type={sourceTypeFor(filename)} onError={() => setFailed(true)} />
		</video>
	);
}
